import React from "react";
import { useNavigate } from "@reach/router";
import { trialClassCheckoutRoute } from "../../utils";
import logotipoPrimary from "../../assets/rebrand/logotipo-primary.png";

const MonterreyLandingAbout = ({ branch_id }) => {
  const navigate = useNavigate();

  const membersImage = `https://thebodymethod.s3.us-west-1.amazonaws.com/${
    branch_id === 2 ? "tj-members.jpg" : "tbmonline-landing-metodo.jpg"
  }`;

  return (
    <div id="scrollspyAbout" className="container-fluid monterrey-about">
      <div className="row w-100 mx-auto align-items-stretch">
        {/* Mobile Image */}
        <div className="col-12 show-mobile px-0">
          <img
            alt="tbm members"
            src={membersImage}
            style={{ borderRadius: '25px', objectFit: 'cover' }}
            className="w-100"
          />
        </div>

        {/* Left Side */}
        <div className="col-12 col-md-6 px-0 features__container">
          <img className="logo d-block w-100" src={logotipoPrimary} alt="The Body Method" />
          <p className="monterrey-about__desc mb-0">
            Más que un lugar para entrenar, TBM es una comunidad que ha acompañado a miles de mujeres a construir una relación más fuerte, constante y consciente con el movimiento. Estos números reflejan el alcance de una experiencia que sigue creciendo dentro y fuera del studio.
          </p>
          <p className="monterrey-about__desc">
            Impactando su vida de manera positiva con un método fitness único
            respaldado por la ciencia.
          </p>

          <div className="row w-100 mx-auto">
            <div className="col-6 mb-md-5">
              <div className="row mb-5 monterrey-about__feature">
                <p className="feature__numb">+800</p>
                <p className="feature__name">MIEMBROS ACTIVOS</p>
              </div>
              <div className="row monterrey-about__feature">
                <p className="feature__numb">+1500</p>
                <p className="feature__name">CERTIFICACIONES COMPLETADAS</p>
              </div>
            </div>

            <div className="col-6 mb-md-5">
              <div className="row mb-5 monterrey-about__feature">
                <p className="feature__numb">+800</p>
                <p className="feature__name">CLASES ONLINE</p>
                <span className="feature__desc">
                  En la compra de cualquier de cualquier paquete presencial
                </span>
              </div>
              <div className="row monterrey-about__feature">
                <p className="feature__numb">+7500</p>
                <p className="feature__name">TRANSFORMACIONES</p>
              </div>
            </div>
          </div>

          <div className="row w-100 mx-auto">
            <button
              type="button"
              className={`btn monterrey-landing__cta monterrey-about__btn bold px-5 ${branch_id === 2 ? "bg-gradient-landing--tijuana text-dark" : "bg-gradient-landing text-white"}`}
              onClick={() => navigate(trialClassCheckoutRoute)}
            >
              COMIENZA YA
              <i className="fas fa-arrow-right ms-2" />
            </button>
          </div>
        </div>
        {/* Right Side */}
        <div className="col-6 hide-mobile ms-auto d-flex min-vh-0 d-none d-md-flex align-items-center">
          <img
            alt="tbm members"
            src={membersImage}
            style={{ borderRadius: '25px', objectFit: 'cover' }}
            className="mw-100 w-100 align-self-stretch"
          />
        </div>
      </div>
    </div>
  );
};

export default MonterreyLandingAbout;
